import React from 'react'

const PHPIcon = () => {
  return (
    <svg fill="#A5A3AE" width="16" height="17" viewBox="1 0 20 20" id="phillippine-peso" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" className="icon flat-color"><path id="primary" d="M20,10H17.92a6.29,6.29,0,0,0,0-2H20a1,1,0,0,0,0-2H17.31A7,7,0,0,0,11,2H8A1,1,0,0,0,7,3V6H4A1,1,0,0,0,4,8H7v2H4a1,1,0,0,0,0,2H7v9a1,1,0,0,0,2,0V16h2a7,7,0,0,0,6.31-4H20a1,1,0,0,0,0-2ZM9,4h2a5,5,0,0,1,4,2H9ZM9,8h6.9a5.05,5.05,0,0,1,0,2H9Zm2,6H9V12h6A5,5,0,0,1,11,14Z"></path></svg>
  )
}

export default PHPIcon